
import { Options, Vue } from 'vue-class-component';
import UserService from "@/services/UserService";
import { RecordIdentifier } from "@/data/global";
import { Course, CourseEnrollment } from "@/data/course";
import UserCourseEnrollment from "@/components/UserCourseEnrollment.vue";


@Options({
    props: {

    },
    components: {
        UserCourseEnrollment,
    },
})
export default class UserCoursesArchive extends Vue {
    // regionId!: number

    loading = true

    courseEnrollments: CourseEnrollment[] = []

    loadData() {
        this.loading = true;
        return UserService.getEnrollmentsArchive().then(result => {
            this.courseEnrollments = result.data.courses;
        }).finally(() => this.loading = false);
    }

    mounted() {
        this.loadData();
    }
}
